/** Account search history API (max 4 server-side, NO alerts). */
import { apiClient } from "./client";

export async function fetchSearchHistory() {
  const r = await apiClient.get("/me/search-history");
  return r.data;
}

export async function recordSearchHistory(entry) {
  const r = await apiClient.post("/me/search-history", entry);
  return r.data;
}

export async function deleteSearchHistory(entryId) {
  const r = await apiClient.delete(`/me/search-history/${entryId}`);
  return r.data;
}
